import { ThemeProvider } from '@si/components';
import { useUser } from '@si/hooks';

import { App } from './App';
import { SalesDemoGate } from './features/sales-demo/SalesDemoGate';
import { useAuth } from './useAuth';

export function UserTheme() {
  const { user } = useUser();
  const { authenticated } = useAuth();
  return (
    <ThemeProvider userId={authenticated ? user?.userId : undefined}>
      <SalesDemoGate>
        <App />
      </SalesDemoGate>
    </ThemeProvider>
  );
}
